import React, { useCallback, useEffect, useState } from "react";
import { adminApi } from "../adminApi";
import ExpertAdminRequestDetail from "./ExpertAdminRequestDetail";

const tableCard = { background: "white", borderRadius: 12, border: "1px solid #E5E7EB", overflow: "hidden" };
const td = { padding: "10px 14px", fontSize: 12.5, color: "#0F1B2D", borderTop: "1px solid #F1F5F9", verticalAlign: "top" };
const th = { padding: "10px 14px", fontSize: 11, color: "#6B7280", textTransform: "uppercase", letterSpacing: 1, textAlign: "left", borderBottom: "1px solid #E5E7EB", fontWeight: 700 };

const STATUS_TONE = {
  new: "#1D4ED8", under_review: "#B45309", assigned: "#7C3AED",
  in_progress: "#047857", completed: "#0F1B2D", closed: "#6B7280",
};

export default function ExpertAdminRequests() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState(null);
  const [migrationRequired, setMigrationRequired] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    const res = await adminApi.expertListRequests({ status: status || undefined });
    if (res.ok) { setRows(res.data.requests || []); setMigrationRequired(!!res.data.migration_required); }
    setLoading(false);
  }, [status]);
  useEffect(() => { load(); }, [load]);

  if (migrationRequired) {
    return <div style={{ ...tableCard, padding: 16, color: "#B45309", fontSize: 13 }}>
      C-ORE Expert tables aren't migrated yet — run backend/migrations/2026-08_core_expert.sql in Supabase.
    </div>;
  }

  return (
    <div data-testid="expert-admin-requests">
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <select data-testid="expert-admin-status-filter" value={status} onChange={(e) => setStatus(e.target.value)}
          style={{ height: 32, padding: "0 8px", border: "1px solid #D1D5DB", borderRadius: 6, fontSize: 12 }}>
          <option value="">All statuses</option>
          {["new", "under_review", "assigned", "in_progress", "completed", "closed"].map((s) => (
            <option key={s} value={s}>{s.replace("_", " ")}</option>
          ))}
        </select>
      </div>
      <div style={tableCard}>
        <table data-testid="expert-admin-requests-table" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={th}>Company</th><th style={th}>Category</th><th style={th}>Plan</th>
              <th style={th}>Priority</th><th style={th}>Status</th><th style={th}>Created</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td style={td} colSpan={6}>Loading…</td></tr>}
            {!loading && rows.length === 0 && <tr><td style={td} colSpan={6}>No requests yet.</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`expert-request-row-${r.id}`} style={{ cursor: "pointer" }}
                onClick={() => setSelectedId(r.id)}>
                <td style={td}>
                  <div style={{ fontWeight: 700 }}>{r.company_name || r.customer_name || r.customer_id}</div>
                  <div style={{ color: "#6B7280" }}>{r.customer_name || "—"}</div>
                </td>
                <td style={td}>{r.category}</td>
                <td style={td}>—</td>
                <td style={td}>{r.priority}</td>
                <td style={td}><span style={{ color: STATUS_TONE[r.status] || "#0F1B2D", fontWeight: 700 }}>{r.status}</span></td>
                <td style={td}>{new Date(r.created_at).toLocaleDateString("en-IN")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selectedId && (
        <ExpertAdminRequestDetail requestId={selectedId} onClose={() => setSelectedId(null)}
          onChanged={load} />
      )}
    </div>
  );
}
